/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { PaginatedModelOfMessageDeliveryStatusDto } from '../model/paginatedModelOfMessageDeliveryStatusDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class MessageDeliveryStatusService {

    protected basePath = 'http://10.1.1.123:30116';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param startDate 
     * @param endDate 
     * @param referenceNumber 
     * @param skip 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public messageDeliveryStatusGetAll(startDate?: Date, endDate?: Date, referenceNumber?: string, skip?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<PaginatedModelOfMessageDeliveryStatusDto>;
    public messageDeliveryStatusGetAll(startDate?: Date, endDate?: Date, referenceNumber?: string, skip?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaginatedModelOfMessageDeliveryStatusDto>>;
    public messageDeliveryStatusGetAll(startDate?: Date, endDate?: Date, referenceNumber?: string, skip?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaginatedModelOfMessageDeliveryStatusDto>>;
    public messageDeliveryStatusGetAll(startDate?: Date, endDate?: Date, referenceNumber?: string, skip?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate.toISOString());
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate.toISOString());
        }
        if (referenceNumber !== undefined && referenceNumber !== null) {
            queryParameters = queryParameters.set('referenceNumber', <any>referenceNumber);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PaginatedModelOfMessageDeliveryStatusDto>(`${this.basePath}/api/MessageDeliveryStatus/GetAll`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param startDate 
     * @param endDate 
     * @param referenceNumber 
     * @param skip 
     * @param take 
     * @param creatorId 
     * @param searchword 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public messageDeliveryStatusGetAllDeliveryStatus(startDate?: Date, endDate?: Date, referenceNumber?: string, skip?: number, take?: number, creatorId?: string, searchword?: string, observe?: 'body', reportProgress?: boolean): Observable<PaginatedModelOfMessageDeliveryStatusDto>;
    public messageDeliveryStatusGetAllDeliveryStatus(startDate?: Date, endDate?: Date, referenceNumber?: string, skip?: number, take?: number, creatorId?: string, searchword?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaginatedModelOfMessageDeliveryStatusDto>>;
    public messageDeliveryStatusGetAllDeliveryStatus(startDate?: Date, endDate?: Date, referenceNumber?: string, skip?: number, take?: number, creatorId?: string, searchword?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaginatedModelOfMessageDeliveryStatusDto>>;
    public messageDeliveryStatusGetAllDeliveryStatus(startDate?: Date, endDate?: Date, referenceNumber?: string, skip?: number, take?: number, creatorId?: string, searchword?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {








        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate.toISOString());
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate.toISOString());
        }
        if (referenceNumber !== undefined && referenceNumber !== null) {
            queryParameters = queryParameters.set('referenceNumber', <any>referenceNumber);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }
        if (searchword !== undefined && searchword !== null) {
            queryParameters = queryParameters.set('searchword', <any>searchword);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PaginatedModelOfMessageDeliveryStatusDto>(`${this.basePath}/api/MessageDeliveryStatus/GetAllDeliveryStatus`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
